// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608270934/js/" + chunkId + "." + {"44":"7c82de55","225":"551a0eba","481":"6b6629d3","486":"a5d2b673","770":"f3c551e6"}[chunkId] + ".0.16348925754246046.chunk.js";
};